import CartIcon from '@/fo/icons/base/tabbar/cart.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import PlusIcon from '../../icons/plus.svg';

import { styles } from './ButtonBuy.styles';

type NativeElement = React.HTMLAttributes<HTMLButtonElement>;

export interface ButtonBuyProps {
  className?: string;
  isInCart: boolean;
  onClick?: NativeElement['onClick'];
  disabled?: boolean;
  loading?: boolean;
}

export function ButtonBuy({
  className,
  isInCart,
  onClick,
  disabled,
  loading
}: ButtonBuyProps) {
  const slots = styles({ isInCart });
  return (
    <UiKitButtonBase
      className={slots.base({ className })}
      rounded="full"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      data-mobile-app-hidden="commerce"
    >
      <CartIcon />
      {isInCart && <PlusIcon className={slots.plusIcon()} />}
    </UiKitButtonBase>
  );
}
